"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.groupCategories = void 0;

var _categories = require("@insided/shared/utils/categories");

var groupCategories = function groupCategories(categories, isKnowledgeBaseEnabled, isGroupsEnabled) {
  var filteredKnowledgeBaseCategories = [];
  var filteredGroupCategories = [];

  if (isKnowledgeBaseEnabled) {
    filteredKnowledgeBaseCategories = categories[(0, _categories.getTypeFromModuleName)(_categories.MODULE.KNOWLEDGE_BASE)];
  }

  if (isGroupsEnabled) {
    filteredGroupCategories = categories[(0, _categories.getTypeFromModuleName)(_categories.MODULE.GROUPS)];
  }

  var filteredCommunityCategories = categories[(0, _categories.getTypeFromModuleName)(_categories.MODULE.COMMUNITY)];
  return {
    knowledgeBase: filteredKnowledgeBaseCategories,
    community: filteredCommunityCategories,
    groups: filteredGroupCategories
  };
};

exports.groupCategories = groupCategories;